import { BACKEND_URL } from "../common/utils/api";

const makeHeaders = (user, t) => {
  const header = [];

  header.push({
    to: "/users/current",
    title: t("user.accountDetails", "Account Details"),
    desc: t(
      "user.viewAndChangeAccountInformation",
      "View and change account information.",
    ),
  });

  if (user?.user?.is_superuser) {
    header.push(
      {
        to: `${BACKEND_URL}/admin/`,
        external: true,
        title: t("user.admin", "Admin"),
        desc: t("user.manageUsers", "Manage users etc."),
      },
      {
        to: "/impersonate",
        action: "impersonate",
        title: t("user.impersonate", "Impersonate"),
        desc: t("user.impersonateDescription", "Impersonate another user"),
      },
    );
  }

  return header;
};
export default makeHeaders;
